import { useHouseholds } from '@platewell/query';
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { acceptInvite } from '../lib/api.js';
import { inviteRoute } from '../router.js';

export function AcceptInvite() {
  const { token } = inviteRoute.useParams();
  const { reloadHouseholds, setActiveHousehold } = useHouseholds();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void acceptInvite(token)
      .then(async ({ householdId }) => {
        if (cancelled) return;
        await reloadHouseholds();
        setActiveHousehold(householdId);
        void navigate({ to: '/' });
      })
      .catch((cause: unknown) => {
        if (!cancelled) setError(cause instanceof Error ? cause.message : 'Invite is not valid');
      });
    return () => {
      cancelled = true;
    };
  }, [token, reloadHouseholds, setActiveHousehold, navigate]);

  return (
    <div className="empty">
      {error == null ? (
        <h2>Joining the household…</h2>
      ) : (
        <>
          <h2>That invite did not work</h2>
          <p className="hint">{error}</p>
        </>
      )}
    </div>
  );
}
